/**
 * nomDecideur.ts — P-S232-39 Q3 (Carl, 4 nov. 2026, 11 h 28 : « le nom du décideur tapé après « Non » survit au rechargement ; la carte ne
 * repose pas la question »). Le nom en cours de saisie est gardé par décision dans sessionStorage (comme ub-chantier-a-ouvrir,
 * useHierarchieChantiers.ts), relu au montage de la boîte Décision (BoitesGreffier.BoitesDecisions) et oublié après une réponse 2xx du
 * serveur (un 422 ou une erreur réseau le garde). Fonctions pures sur le stockage, jamais bloquantes (try/catch).
 */
const CLE = (decisionId: number) => `ub-nom-decideur:${decisionId}`;

function stockage(): Storage | null {
  try { return typeof sessionStorage !== "undefined" ? sessionStorage : null; } catch { return null; }
}

/** Garde le nom tapé (vide : oublie). */
export function garderNom(decisionId: number, nom: string): void {
  try { const s = stockage(); if (!s) return; if (nom) s.setItem(CLE(decisionId), nom); else s.removeItem(CLE(decisionId)); } catch { /* stockage indisponible */ }
}

export function lireNom(decisionId: number): string {
  try { return stockage()?.getItem(CLE(decisionId)) || ""; } catch { return ""; }
}

export function oublierNom(decisionId: number): void {
  try { stockage()?.removeItem(CLE(decisionId)); } catch { /* rien */ }
}

/** Vrai quand un nom est en cours de saisie pour cette décision : la carte « Qui approuve » ne repose pas la question. */
export function nomEnCours(decisionId: number | string | null | undefined): boolean {
  return typeof decisionId === "number" && lireNom(decisionId) !== "";
}

/** La décision de la boîte dont un nom est en cours (la première), ou null. */
export function decisionAvecNomEnCours(ids: number[]): number | null {
  for (const id of ids) if (nomEnCours(id)) return id;
  return null;
}
